
import Clarity from '@microsoft/clarity';
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { CLARITY_PROJECT_ID } from '../../../project_config';
import { api } from "../../../utils/api";
import { LoginHelper } from "../../../utils/LoginHelper";
import Breadcrumb from "../../common/breadcrumb/Breadcrumb";
import Footer from "../../common/footer/Footer";
import Header from "../../common/header/Header";
import AddAnswerSection from "./add_answer/AddAnswerSection";
import AnswerSection from "./answer/AnswerSection";
import QuestionSection from "./question/QuestionSection";

export default function DiscussionDetail() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
	const params = useParams();
	const discussionId = params.discussionId;
	const linkDataList = [
		{ label: 'خانه', href: '/' },
		{ label: 'تالار', href: '/discussion_list/' },
		{ label: 'گفتگو', href: '/discussion_detail/' + discussionId + '/' },
	];
	const [discussion, setDiscussion] = useState(null);
	const [errorMessage, setErrorMessage] = useState('');

	useEffect(() => {
		fetchDiscussion();
	}, []);

	useEffect(() => {
		document.title = `گفتگوی ${discussion?.title || ''} | همراهتیم`;
	}, [discussion]);

	function fetchDiscussion() {
		api.discussionDetail({
			token: LoginHelper.getToken(),
			discussion_id: discussionId,
		}).then((result) => {
			setDiscussion(result);
		}).catch((err) => {
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		})
	}

	return (
		<>
			<Helmet>
				<title>گفتگوی {discussion?.title || ''} | همراهتیم</title>
				<meta name="description" content="گفتگوی {discussion?.title || ''} به همراهتیم" />
			</Helmet>

			<div className="bg-[#F0F6FC] min-h-screen flex flex-col justify-between">
				<div>
					<Header isDesktop={isDesktop} />
					<div className="bg-white">
						<div className={`${isDesktop ? 'w-[800px]' : ''} mx-auto`}>
							<Breadcrumb linkDataList={linkDataList} />
						</div>
					</div>
					<div className="spacer p-[50px]"></div>
					<div className={`${isDesktop ? 'w-[800px]' : 'p-[10px]'} mx-auto`}>
						{discussion && (
							<>
								<QuestionSection discussion={discussion} onReloadNeeded={() => fetchDiscussion()} />
								<div className="spacer p-[10px]"></div>
								<AnswerSection discussion={discussion} onReloadNeeded={() => fetchDiscussion()} />
								<div className="spacer p-[10px]"></div>
								<AddAnswerSection discussion={discussion} onReloadNeeded={() => fetchDiscussion()} />
							</>
						)}
						{errorMessage && (
							<>
								<div className="spacer p-[50px]"></div>
								<div className="text-center font-Vazir-400 text-[#cc0000]">{errorMessage}</div>
							</>
						)}
					</div>
				</div>
				<div className="spacer p-[50px]"></div>
				<div>
					<Footer isDesktop={isDesktop} />
				</div>
			</div>
		</>
	)
}
